import { TooltipTrigger } from '@design';
import {
  TooltipContainer,
  TooltipContainerProps,
} from '@terminal/components/tooltip-container/TooltipContainer';
import React, { cloneElement } from 'react';

export interface TruncateTooltipProps
  extends Omit<TooltipContainerProps, 'label'> {
  text: string;
  atLength: number;
  id?: string;
  tooltipText?: string;
  fallbackLabel?: React.ReactElement;
  truncatedLabelWrapper?: React.ReactElement<Record<string, unknown>>;
}

const SUFFIX = '...';

export const TruncateTooltip = ({
  text,
  atLength,
  id,
  tooltipText,
  fallbackLabel,
  truncatedLabelWrapper = <span id={id} data-testid="truncated-text" />,
  inPortal,
  ...rest
}: TruncateTooltipProps) => {
  const truncatedText = `${text.substring(
    0,
    atLength - SUFFIX.length
  )}${SUFFIX}`;

  if (text.length > atLength) {
    return (
      <TooltipContainer
        label={tooltipText ?? text}
        inPortal={inPortal}
        trigger={[TooltipTrigger.Hover]}
        {...rest}
      >
        {cloneElement(truncatedLabelWrapper, {
          children: truncatedText,
          ...rest,
        })}
      </TooltipContainer>
    );
  }

  return (
    fallbackLabel ?? (
      <span id={id} data-testid="text">
        {text}
      </span>
    )
  );
};
